/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=3baa0965&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=3baa0965&scoped=true&lang=css"
import "./index.vue?vue&type=style&index=1&id=3baa0965&lang=css"

import exportComponent from "D:\\un-app\\zsmy_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3baa0965"]])

export default __exports__